import React, { useEffect, useState } from "react";
import "./UpcomingMeetings.css";
import DynamicFilter from "Components/ReusableComponents/filter";
import { Card, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import useCustomizeDash from "hooks/useCustomizeDash";
import HELPERS from "utils/helper";
import DASHBOARD_API from "api/dashboard";
import PopupForm from "Components/ReusableComponents/UpcomingMeetingsPopupForm";
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectUpcomingMeetings, selectUpcomingMeetingsFilters, setUpcomingMeetingsAsync, setUpcomingMeetingsFiltersAsync } from "slices/dashboardSlice";
import moment from "moment";

const UpcomingMeetings = ({setLeftSections, setRightSections, compID, left, tmpState, setTmpState}) => {
  
  const upcomingMeetings = useSelector(selectUpcomingMeetings);
  const meetingType = useSelector(selectUpcomingMeetingsFilters)
    
  // console.log('sss updateUpcomingMettings', upcomingMeetings)

  const [meetingsData, setMeetingsData] = useState(upcomingMeetings);
  const [sortedData, setSortedData] = useState(upcomingMeetings);
  const [currentFilter, setCurrentFilter] = useState(null);
  const [toggling, setToggling] = useState(false);
  const [formData, setFormData] = useState([]);
  const { isDropdownOpen } = useCustomizeDash();
  const userId = HELPERS.getUserId();
  const dispatch = useDispatch();

  const getDateCategory = (dateString) => {
    const meetingDate = new Date(dateString);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
  
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
  
    const nextWeek = new Date(today);
    nextWeek.setDate(today.getDate() + 7);
  
    const nextMonth = new Date(today);
    nextMonth.setMonth(today.getMonth() + 1);
  
    if (meetingDate.toDateString() === today.toDateString()) return "Today";
    if (meetingDate.toDateString() === tomorrow.toDateString()) return "Tomorrow";
    if (meetingDate > tomorrow && meetingDate <= nextWeek) return "Next Week";
    if (meetingDate > nextWeek && meetingDate <= nextMonth) return "Next Month";
    return "Later";
  };

  useEffect(() => {
    setMeetingsData(upcomingMeetings);
    setSortedData(upcomingMeetings);
  }, [upcomingMeetings]);

  const handleFilterChange = (sortedData, filterKey) => {
    console.log('sss filterKey sortedData', sortedData, filterKey)
    setSortedData(sortedData);
    setCurrentFilter(filterKey);
  };

  const meetingTypeFilters = Object.entries(meetingType).map(([key, label]) => {
    return {
      key: key,
      label: label,
      category: "Type",
      filterCondition: (meeting) => meeting.type === key
    };
  });  

  const filterOptions = [
    { key: "Today", label: "Today", category: "Date", filterCondition: (meeting) => getDateCategory(meeting.date) === "Today" },
    { key: "Tomorrow", label: "Tomorrow", category: "Date", filterCondition: (meeting) => getDateCategory(meeting.date) === "Tomorrow" },
    { key: "Next Week", label: "Next Week", category: "Date", filterCondition: (meeting) => getDateCategory(meeting.date) === "Next Week" },
    { key: "Next Month", label: "Next Month", category: "Date", filterCondition: (meeting) => getDateCategory(meeting.date) === "Next Month" },
    ...meetingTypeFilters
  ];

  const handleDelete = () => {
    // left ? setLeftSections((prev) => prev.filter((section) => section.id !== compID)) : setRightSections((prev) => prev.filter((section) => section.id !== compID));
    try {
      const payload = { "step_id": compID, "user_id": userId }
      console.log("sss delete", payload);
      DASHBOARD_API.deleteDashboardItem(payload)
      .then((response) => {
        console.log("sss delete api response", response);
        message.success("Your work has been saved")
        setTmpState(!tmpState)
      })
      .catch((err) => {
        console.log("sss delete api error", err, payload);
        message.error("Your work has not been saved")
      });
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const handleSave = async (values) => {
    console.log('sss handleSave upcoming meet', values, meetingType[values.otherMeetingType])
    // return false

    if (values.meetingType === "OTH" && !meetingType[values.otherMeetingType]) {
      // const updatedMeetingTypes = {
      //   ...meetingType,
      //   [values.otherMeetingType]: values.otherMeetingType,
      // };
      // dispatch(setUpcomingMeetingsFiltersAsync(updatedMeetingTypes, userId));
    }

    if (values.meetingId === '' || values.meetingId === undefined || values.meetingId === null){
      const newMeeting = {
        id: moment().valueOf(),
        title: values.meeting_name,
        date: values.meetingDateTime ? values.meetingDateTime.format("YYYY-MM-DD") : "",
        time: values.meetingDateTime ? values.meetingDateTime.format("hh:mm A") : "",
        type: values.otherMeetingType ? values.otherMeetingType : values.meetingType,
        timezone: values.timezone,
      };

      setMeetingsData((prevData) => {
        // console.log("Previous data:", prevData);
        // console.log("Is array:", Array.isArray(prevData));

        const updatedData = [...(Array.isArray(prevData) ? prevData : []), newMeeting];
        message.success("Your work has been saved")
        dispatch(setUpcomingMeetingsAsync(updatedData, userId));
        return updatedData;
      });
    }
    else{
      setMeetingsData((prevData) => {
        console.log("sss Previous data:", prevData, values);
        // console.log("Is array:", Array.isArray(prevData));

        const updatedData = prevData.map((item) => 
          (item.id === values.meetingId)
          ? {
              ...item,
              title: values.meeting_name,
              // type: values.meetingType,
              type: values.otherMeetingType ? values.otherMeetingType : values.meetingType,
              date: values.meetingDateTime.format("YYYY-MM-DD"),
              time: values.meetingDateTime.format("hh:mm A"),
              timezone: values.timezone,
            }
          : item          
        )
        message.success("Your work has been saved")
        dispatch(setUpcomingMeetingsAsync(updatedData, userId));
        return updatedData;
      });
    }
  }


  return (
  <>
    <Card
      bordered={false}
      style={{
        boxShadow: "0px 3px 16px 0px #1313131A",
        borderRadius: "12px",
        textAlign: "left",
        margin: "0px 20px",
        height: "fit-content",
      }}
    >
      <div className="h" style={{ fontWeight: "bold", textAlign: "left" }}>

        <div className="stg-header">
          <div className="stg-left-header">
            <img
              src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/dashboardMyTasksDrag.svg"
              className="stg-icon"
              alt="drag icon"
            />
            <span className="my-career-roadmap-title">Upcoming Meetings</span>
          </div>
          {
            isDropdownOpen ? (
              <img
                src="https://django-woken-static.s3.amazonaws.com/static/media/compRemove.svg"
                alt="delete icon"
                className="delete-icon"
                style={{
                  cursor: "pointer",
                }}
                onClick={handleDelete}
              />
            ) : (
              <DynamicFilter
                onFilterChange={handleFilterChange}
                filterOptions={filterOptions}
                currentFilter={currentFilter}
                // placeholder="Filter by:" 
                data={meetingsData}  
              />
            )
          }
        </div>
      </div>

      <div className="meetings-list">
      {console.log(sortedData, "testing sorted data formData", formData)}
      {Array.isArray(sortedData) && sortedData.map((meeting, index) => (
          <div key={index} className="meeting-card">
            <div className="meeting-info" onClick={() => {
                setFormData(meeting)
                setToggling(true)
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: 'space-between',
                  columnGap: "10px",
                }}
              >
                <div className="meeting-title">
                  <h3>{meeting.title}</h3>
                </div>
                <div className="meeting-type" style={{ color: "#008080" }}>
                  <span>
                    ● 
                  </span>
                  {/* &nbsp;&nbsp;&nbsp; */}
                  <span
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    {meetingType[meeting.type]}
                  </span>
                </div>
              </div>
              <div className="meeting-time">
                <p>
                  {moment(meeting.date).format("MM/DD/YYYY")} • {meeting.time}  {meeting.timezone?.includes("—")
                    ? meeting.timezone.split("—")[0].trim()
                    : meeting.timezone}
                </p>
              </div>
            </div>
            {/* <div style={{
              textAlign: "right",
            }}>
              <div className="meeting-type" style={{ color: "#008080" }}>
                <span>
                  ● 
                </span>
                <span>
                  {meetingType[meeting.type]}
                </span>
              </div>
            </div> */}
          </div>
        ))}
      </div>
      <button className="add-meeting button-main"
        onClick={() => {
          setToggling(true)
          setFormData([])
        }}
      ><PlusOutlined />  Add New Meeting</button>

      {toggling &&
        ReactDOM.createPortal(
          <PopupForm
            onSave={handleSave}
            onCancel={() => setToggling(false)}
            formData={formData}
          />,
          document.body
        )}
      
    </Card>
  
  </>
  );
};

export default UpcomingMeetings;
